/**
 * Just a noop function to use as a default callback.
 */
export default function noop() { }
